document.querySelectorAll('input[name="lead[intereses]"]').forEach((elem) => {
  elem.addEventListener('change', function(event) {
    let itemRadioButton = event.target;

    const url = new URL(location)
    url.pathname = itemRadioButton.getAttribute('data-url')
    url.search = `?ponencia_id=${itemRadioButton.getAttribute('data-ponencia')}&intereses=${itemRadioButton.getAttribute('data-intereses')}`

    let gpdrContainer = document.getElementById('gdpr');

    event.loading = ''
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        gpdrContainer.innerHTML = responseText
        delete event.loading
      })
  });
});

window.addEventListener('pageshow', function(event) {
  document.querySelectorAll('input[name="lead[intereses]"]').forEach((elem) => {
    if (elem.checked) {
      const url = new URL(location)
      url.pathname = elem.getAttribute('data-url')
      url.search = `?ponencia_id=${elem.getAttribute('data-ponencia')}&intereses=${elem.getAttribute('data-intereses')}`

      let gpdrContainer = document.getElementById('gdpr');

      event.loading = ''
      fetch(url)
        .then(response => response.text())
        .then(responseText => {
          gpdrContainer.innerHTML = responseText
          delete event.loading
        })
      }
  });
});
